import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from 'src/constants/queries';
import { Insights } from 'src/api/Insights';
import useApi from './useApi';
import useAuth from './useAuth';
import useTeams from './useTeams';
const useInsights = () => {
  const $ = _c(16);
  const insightClient = useApi(Insights);
  const {
    isAuthenticated
  } = useAuth();
  const {
    currentTeam
  } = useTeams();
  const teamId = currentTeam?.id || "";
  let t0;
  if ($[0] !== teamId) {
    t0 = [QUERY_KEYS.INSIGHTS.LIST, teamId];
    $[0] = teamId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== insightClient || $[3] !== teamId) {
    t1 = async () => {
      const response = await insightClient.getInsights(teamId);
      const {
        data
      } = response;
      if (!data) {
        throw new Error("Invalid insight response format");
      }
      return data;
    };
    $[2] = insightClient;
    $[3] = teamId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = !!teamId && !!isAuthenticated;
  let t3;
  if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      staleTime: 900000
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    data: data_0,
    isLoading,
    refetch: fetchInsights,
    isError
  } = useQuery(t3);
  let t4;
  if ($[9] !== data_0) {
    t4 = data_0 ?? [];
    $[9] = data_0;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== fetchInsights || $[12] !== isError || $[13] !== isLoading || $[14] !== t4) {
    t5 = {
      fetchInsights,
      insights: t4,
      isLoading,
      isError
    };
    $[11] = fetchInsights;
    $[12] = isError;
    $[13] = isLoading;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
export default useInsights;